import styled from 'styled-components';

import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';

export const CustomSwiper = styled(NukaCarousel)`
    padding-left: 0 !important;
    padding-right: 0 !important;
    
    & section,
    & div {
        outline: none;
    }

    & > section > div.slider-frame {
        padding: 24px 0 !important;

        div.slider-list {
            cursor: default !important;
        }
    }
`;
